module.exports = __webpack_public_path__ + "assets/0cbe2affc78114bbecb29ce0cef7ee22.svg";